document.addEventListener("DOMContentLoaded", () => {
  if (BSS_B2B) {
    const searchInputs = document.querySelectorAll("input.search-bar__input");
    if (searchInputs.length) {
      searchInputs.forEach((input) => {
        input.addEventListener("input", () => {
          setTimeout(() => {
            BSS_B2B.changeProductPriceWithInterval();
          }, 1000);
        });
      });
    }
    const modal_mini_cart = document.querySelector("#mini-cart");
    if (modal_mini_cart) {
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          BSS_B2B.cart.fixer(
            JSON.parse($("#bss-b2b-store-data").html()),
            false,
            false
          );
        }, 500);
      });
      observer.observe(modal_mini_cart, { attributes: true });

      modal_mini_cart.addEventListener("click", () => {
        setTimeout(() => {
          BSS_B2B.cart.fixer(
            JSON.parse($("#bss-b2b-store-data").html()),
            false,
            false
          );
        }, 1000);
      });
    }

    document.addEventListener("bss_b2b_doneCheckCp", () => {
      setTimeout(() => {
        const check = BSS_B2B.td.getAppliedRuleCollectionPage(
          BSS_B2B,
          JSON.parse($("#bss-b2b-store-data").html())
        );
        if (check) {
          const bss_customs = document.querySelectorAll(".bss-custom-compare");
          const bss_customs_hide = document.querySelectorAll(
            ".bss-custom-compare__hidden"
          );
          if (bss_customs.length) {
            bss_customs.forEach((ele) => {
              ele.style.display = "flex";
              ele.style.flexDirection = "column";
            });
          }
          if (bss_customs_hide.length) {
            bss_customs_hide.forEach((ele) => {
              ele.style.display = "none";
            });
          }
        }
      }, 1000);
    });
  }

  // fix colletion
  setTimeout(() => {
    const summary = document.querySelector(".gf-summary");
    if (summary) {
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          BSS_B2B.changeProductPriceWithInterval();
          console.log("call");
        }, 300);
      });
      observer.observe(summary, { childList: true, subtree: true });
    }
  }, 1000);
});


// start BSS fix css for register page
if (window.location.pathname.includes("/pages/")) {
  setTimeout(() => {
    $('#RegisterForm input:not([type="checkbox"]):not([type="file"]):not(.country-field):not([type="hidden"]):not([type="submit"])').each((_, input) => {
      $(input).attr("placeholder", " ");
      let label = $(input).parent().find('label')
      if (label.length == 0) label = $(input).parent().parent().find('label')
      $(input).parent().css("position", "relative")
      $(input).after(label)
    })
  }, 200)
}
// end BSS fix css for register page

//replace TE box
if (window.location.pathname.includes("/cart")) {
  setTimeout(() => {
    const elm_box = document.querySelector('.card__section button[type="submit"]');
    const te_box = document.querySelector(".bss-b2b-tax-ex-wrapper.bss-config-header");
    if(elm_box && te_box){
      elm_box.before(te_box);
    }

    //fill te box
    if(BSS_B2B.shopData?.customer?.id){
      let input = te_box.querySelector("input.bss-b2b-vat-input");
      if(input){
        const tags = BSS_B2B.shopData?.customer?.tags;
        if(tags.length){
          const findTagVat = tags.find(tag => tag.includes('VAT-ID:'));
          if(findTagVat){
            const vatCheck = findTagVat.split(':');
            if(vatCheck.length){
              const vatId = vatCheck[1];
              if(vatId){
                input.value = vatId;
              }
            }
          }
        }
      }
    }
  }, 100)
}

